// Custom Colors = [RLGold,RLWhite]
/* social link custom colors {
   circle colors: [RLWhite]
   icon colors: [RLRed]
}*/
// if button is colored you must add a fontColor
// to change border color of a colored button add color to additionalstyles
export const PROFILE = {
    title: {
        title: "Ronnie's Links",
        color: 'RLWhite',
        font: '',
    },
    TRCLogo: 'colored',
    profilePic:
        'https://res.cloudinary.com/rightlink/image/upload/v1694697086/RonniesLinks/IMG_9954_kdqfoq.jpg',
    background: {
        imageLink:
            'background-image: url(https://res.cloudinary.com/rightlink/image/upload/v1694812369/RonniesLinks/9d670eab203e4844663d36b5f888b4f9_lrjdcw.jpg)',
        color: 'background-image: linear-gradient(to right top, #00ff80, #00ffbb, #d5fbff, #d5fbff, #ffffff, #ffffff, #ffffff, #ffffff, #d5fbff, #d5fbff, #00ffbb, #00ff80)',
        imageSize: 'cover',
    },
};
export const SOCIAL_LINKS = {
    position: 'bottom',
    group: [
        {
            name: 'Youtube',
            iconName: 'youtube',
            link: 'https://youtube.com/@RonnieLuxeOfficial',
            color: 'blue',
            inverted: true,
            secondaryColor: '',
            surrounded: 'circular',
            surroundedInColor: true,
        },
    ],
};
// featuredTimerDate formats inclued '2020-02-01T01:02:03' or milliseconds e.g 1580518923000 - documentation here https://github.com/ndresx/react-countdown
// for media as links you must set type as 'item' and mainMedia.type as either 'still, mp4, or other(not implemented yet)'
export const LINK_GROUPS = [
    {
        groupName: '',
        groupColor: '',
        groupFont: '',
        group: [
            {
                name: 'For Him Single / Apple Music',
                link: 'https://music.apple.com/us/album/for-him/1709427573',
                linkSpaced: true,
                type: 'still/external',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: false,
                mainMedia: {
                    type: '',
                    link: 'https://res.cloudinary.com/rightlink/image/upload/v1695943767/RonniesLinks/Black_Bold_Minimalist_Photo_Plastic_Texture_Album_Cover_azbdnw.jpg',
                    mediaText: 'For Him Single / Apple Music',
                    videoPoster: '',
                },
                additionalLinks: [],
                color: 'blue',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
            },
            {
                name: 'COOL MOM MEET UP',
                link: 'https://www.eventbrite.com/e/cool-mom-first-meet-up-tickets-724018477757',
                linkSpaced: true,
                type: 'external',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: false,
                mainMedia: {},
                additionalLinks: [],
                color: 'blue',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
            },
            {
                name: 'Rabbit Hole EP',
                link: 'https://music.apple.com/us/album/rabbit-hole-ep/1521195808',
                linkSpaced: true,
                type: 'still/external',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: false,
                mainMedia: {
                    type: '',
                    link: 'https://res.cloudinary.com/rightlink/image/upload/v1694813295/RonniesLinks/rabbit_hole_ogpzqt.jpg',
                    mediaText: 'Rabbit Hole EP',
                    videoPoster: '',
                },
                additionalLinks: [],
                color: 'blue',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
            },
            {
                name: 'The Cool Mom Collective',
                link: 'https://instagram.com/thecoolmomcollective_',
                linkSpaced: true,
                type: 'external',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: false,
                mainMedia: {},
                additionalLinks: [],
                color: 'blue',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
            },
            {
                name: 'BOSS Hair Page',
                link: 'https://instagram.com/bosshairbyvee',
                linkSpaced: true,
                type: 'external',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: false,
                mainMedia: {},
                additionalLinks: [],
                color: 'blue',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
            },
            {
                name: 'Tulips Single / Apple Music',
                link: 'https://music.apple.com/us/album/tulips-single/1644270202',
                linkSpaced: true,
                type: 'external',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: false,
                mainMedia: {},
                additionalLinks: [],
                color: 'blue',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
            },
            {
                name: 'Follow Me On Tik Tok',
                link: 'https://www.tiktok.com/@bosshairbyvee',
                linkSpaced: true,
                type: 'external',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: false,
                mainMedia: {},
                additionalLinks: [],
                color: 'blue',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
            },
            {
                name: 'Follow Me On Youtube',
                link: 'https://youtube.com/@RonnieLuxeOfficial',
                linkSpaced: true,
                type: 'external',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: false,
                mainMedia: {},
                additionalLinks: [],
                color: 'blue',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
            },
        ],
    },
];
